export const removeTab = (str: string) => {
  if (str.includes('\t')) {
    return str.split('\t').join('   ')
  }
  return str
}
